const config = {
  host:
    window.location.href.includes("localhost") ||
    window.location.href.includes("dev")
      ? "dev.bleustay.com"
      : window.location.href.includes("stg")
        ? "stg.bleustay.com"
        : "bleustay.com",
  backendUrl: window.location.href.includes("localhost")
    ? "http://localhost:3000"
    : window.location.href.includes("dev")
      ? "https://merchant.dev.bleustay.com"
      : window.location.href.includes("stg")
        ? "https://merchant.stg.bleustay.com"
        : "https://merchant.bleustay.com",
};

/**
 * The booking site of a hotel in a group, from its site namespace. Locally a
 * namespace is reached as a subdomain of localhost on the same port, or is
 * itself a localhost address.
 */
export function hotelSiteUrl(namespace) {
  const { protocol, hostname, port } = window.location;
  if (namespace.includes("localhost")) return `${protocol}//${namespace}/`;
  if (hostname === "localhost" || hostname.endsWith(".localhost")) {
    return `${protocol}//${namespace}.localhost${port ? `:${port}` : ""}/`;
  }
  return `https://${namespace}.${config.host}/`;
}

export default config;
